export default "__VITE_ASSET__CPLOHFQG__"